module.exports = __webpack_public_path__ + "img/529.f59d66ce.jpg";